import Grid from "./Grid";
import ProductLink from "./ProductLink";
import PropTypes from "prop-types";
import React from "react";

function ProductGrid({
  products,
  desktopCols,
  mobCols,
  brand,
  showCondition,
  showCategoryButtons,
}) {
  return (
    <Grid desktopCols={desktopCols} mobCols={mobCols}>
      {products.map((product) => {
        return (
          <ProductLink
            key={product.slug}
            product={product}
            showBrand={brand ? false : true}
            brandSlug={brand ? brand.slug : null}
            showCondition={showCondition}
            showCategoryButtons={showCategoryButtons}
          />
        );
      })}
    </Grid>
  );
}

export default ProductGrid;

ProductGrid.propTypes = {
  products: PropTypes.array.isRequired,
  desktopCols: PropTypes.number.isRequired,
  mobCols: PropTypes.number.isRequired,
  brand: PropTypes.object,
  showCondition: PropTypes.bool,
};
